// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════════════
   HABIB AI Agent Chat Widget — Navy & Gold Premium Design
   ═══════════════════════════════════════════════════════════════════════════ */

/* ── Variables ──────────────────────────────────────────────────────────────── */
.agent-fab,
.agent-panel {
    --agent-navy:     #0a1628;
    --agent-navy-2:   #0f2044;
    --agent-navy-3:   #162d5c;
    --agent-gold:     #d4af37;
    --agent-gold-lt:  #e8c84d;
    --agent-surface:  rgba(10, 22, 40, 0.97);
    --agent-border:   rgba(212, 175, 55, 0.2);
    --agent-radius:   16px;
    --agent-shadow:   0 20px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(212,175,55,0.15);
    font-family: 'Inter', sans-serif;
}

/* ── Floating Action Button ─────────────────────────────────────────────────── */
.agent-fab {
    position: fixed;
    bottom: 28px;
    right: 28px;
    z-index: 9990;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--agent-navy-3) 0%, var(--agent-navy) 100%);
    border: 2px solid var(--agent-gold);
    color: var(--agent-gold);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 32px rgba(212, 175, 55, 0.3), 0 4px 16px rgba(0,0,0,0.4);
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    outline: none;
}

.agent-fab:hover {
    transform: scale(1.08) translateY(-2px);
    box-shadow: 0 12px 40px rgba(212, 175, 55, 0.45), 0 6px 20px rgba(0,0,0,0.5);
    border-color: var(--agent-gold-lt);
}

.agent-fab--open {
    background: linear-gradient(135deg, #dc3545 0%, #a71d2a 100%);
    border-color: rgba(220, 53, 69, 0.6);
    color: white;
}

.agent-fab--pulse {
    animation: agent-pulse 2s infinite;
}

@keyframes agent-pulse {
    0%, 100% { box-shadow: 0 8px 32px rgba(212,175,55,0.3); }
    50%       { box-shadow: 0 8px 32px rgba(212,175,55,0.7), 0 0 0 12px rgba(212,175,55,0.1); }
}

.agent-fab__badge {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 20px;
    height: 20px;
    background: #dc3545;
    border-radius: 50%;
    font-size: 11px;
    font-weight: 700;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid var(--agent-navy);
    animation: badge-appear 0.3s ease;
}

@keyframes badge-appear {
    from { transform: scale(0); }
    to   { transform: scale(1); }
}

.agent-fab__label {
    position: absolute;
    bottom: -22px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    font-weight: 700;
    color: var(--agent-navy);
    letter-spacing: 0.5px;
    white-space: nowrap;
    text-shadow: 0 0 1px rgba(255,255,255,0.8);
}

/* ── Chat Panel ─────────────────────────────────────────────────────────────── */
.agent-panel {
    position: fixed;
    bottom: 108px;
    right: 28px;
    z-index: 9980;
    width: 400px;
    height: 620px;
    background: var(--agent-surface);
    border: 1px solid var(--agent-border);
    border-radius: var(--agent-radius);
    box-shadow: var(--agent-shadow);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);

    /* animation */
    opacity: 0;
    transform: translateY(20px) scale(0.97);
    pointer-events: none;
    transition: opacity 0.25s ease, transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform-origin: bottom right;
}

.agent-panel--open {
    opacity: 1;
    transform: translateY(0) scale(1);
    pointer-events: all;
}

/* ── Header ─────────────────────────────────────────────────────────────────── */
.agent-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    background: linear-gradient(135deg, var(--agent-navy-3) 0%, var(--agent-navy-2) 100%);
    border-bottom: 1px solid var(--agent-border);
    flex-shrink: 0;
}

.agent-panel__header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.agent-panel__avatar,
.agent-msg__avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: var(--surface-2);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden; /* Important for circular image */
    border: 1px solid var(--gold-400);
}

.agent-fab-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
}

.agent-avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.agent-panel__status {
    position: absolute;
    bottom: 1px;
    right: 1px;
    width: 11px;
    height: 11px;
    background: #22c55e;
    border-radius: 50%;
    border: 2px solid var(--agent-navy-2);
    animation: status-pulse 3s infinite;
}

@keyframes status-pulse {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0.6; }
}

.agent-panel__name {
    font-size: 15px;
    font-weight: 700;
    color: var(--agent-gold);
    letter-spacing: 0.3px;
}

.agent-panel__subtitle {
    font-size: 11px;
    color: rgba(255,255,255,0.5);
    margin-top: 1px;
}

.agent-panel__header-actions {
    display: flex;
    gap: 4px;
}

.agent-panel__action-btn {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.08);
    color: rgba(255,255,255,0.6);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    padding: 0;
}

.agent-panel__action-btn:hover {
    background: rgba(212,175,55,0.15);
    border-color: rgba(212,175,55,0.3);
    color: var(--agent-gold);
}

/* ── Messages ───────────────────────────────────────────────────────────────── */
.agent-panel__messages {
    flex: 1 1;
    overflow-y: auto;
    padding: 16px 14px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    scroll-behavior: smooth;
}

.agent-panel__messages::-webkit-scrollbar {
    width: 4px;
}
.agent-panel__messages::-webkit-scrollbar-track {
    background: transparent;
}
.agent-panel__messages::-webkit-scrollbar-thumb {
    background: rgba(212,175,55,0.2);
    border-radius: 4px;
}
.agent-panel__messages::-webkit-scrollbar-thumb:hover {
    background: rgba(212,175,55,0.4);
}

/* ── Message bubbles ──────────────────────────────────────────────────────── */
.agent-msg {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    animation: msg-appear 0.25s ease;
}

@keyframes msg-appear {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
}

.agent-msg--user {
    flex-direction: row-reverse;
}

.agent-msg__avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--agent-gold) 0%, var(--agent-gold-lt) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 700;
    color: var(--agent-navy);
    flex-shrink: 0;
}

.agent-msg__bubble {
    max-width: 82%;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.agent-msg__name {
    font-size: 11px;
    font-weight: 600;
    color: var(--agent-gold);
    padding-left: 2px;
}

.agent-msg__text {
    padding: 10px 14px;
    border-radius: 14px;
    font-size: 13.5px;
    line-height: 1.55;
    color: rgba(255,255,255,0.92);
    word-break: break-word;
}

.agent-msg--assistant .agent-msg__text {
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.08);
    border-bottom-left-radius: 4px;
}

.agent-msg--user .agent-msg__text {
    background: linear-gradient(135deg, var(--agent-navy-3) 0%, rgba(22,45,92,0.9) 100%);
    border: 1px solid rgba(212,175,55,0.25);
    border-bottom-right-radius: 4px;
    color: rgba(255,255,255,0.95);
}

.agent-msg__text strong { color: var(--agent-gold-lt); font-weight: 600; }
.agent-msg__text em     { color: rgba(255,255,255,0.7); }
.agent-msg__text code   {
    background: rgba(0,0,0,0.4);
    padding: 1px 5px;
    border-radius: 4px;
    font-family: 'Fira Code', monospace;
    font-size: 12px;
    color: var(--agent-gold-lt);
}
.agent-msg__text h3, .agent-msg__text h4 {
    color: var(--agent-gold);
    margin: 8px 0 4px;
    font-size: 13px;
}
.agent-msg__text ul {
    padding-left: 16px;
    margin: 4px 0;
}
.agent-msg__text li {
    margin-bottom: 2px;
    color: rgba(255,255,255,0.85);
}

.agent-msg__time {
    font-size: 10px;
    color: rgba(255,255,255,0.3);
    padding: 0 2px;
    align-self: flex-end;
}

.agent-msg--user .agent-msg__time {
    align-self: flex-end;
    text-align: right;
}

/* ── Typing indicator ──────────────────────────────────────────────────────── */
.agent-typing-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 14px;
    border-bottom-left-radius: 4px;
    align-self: flex-start;
    max-width: 160px;
    animation: msg-appear 0.25s ease;
}

.agent-typing-indicator span {
    width: 7px;
    height: 7px;
    background: var(--agent-gold);
    border-radius: 50%;
    animation: typing-bounce 1.4s infinite ease-in-out;
}
.agent-typing-indicator span:nth-child(2) { animation-delay: 0.2s; }
.agent-typing-indicator span:nth-child(3) { animation-delay: 0.4s; }

@keyframes typing-bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
    40%           { transform: scale(1);   opacity: 1; }
}

.agent-typing-indicator small {
    font-size: 10px;
    color: rgba(255,255,255,0.4);
    white-space: nowrap;
}

/* ── Quick Suggestions ─────────────────────────────────────────────────────── */
.agent-suggestions {
    padding: 8px 4px;
    animation: msg-appear 0.3s ease;
}

.agent-suggestions__label {
    font-size: 11px;
    color: rgba(255,255,255,0.4);
    margin-bottom: 8px;
    padding-left: 2px;
}

.agent-suggestions__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
}

.agent-suggestions__btn {
    background: rgba(212,175,55,0.06);
    border: 1px solid rgba(212,175,55,0.2);
    border-radius: 10px;
    color: rgba(255,255,255,0.75);
    font-size: 11.5px;
    padding: 8px 10px;
    cursor: pointer;
    text-align: left;
    font-family: 'Inter', sans-serif;
    transition: all 0.2s;
    line-height: 1.3;
}

.agent-suggestions__btn:hover {
    background: rgba(212,175,55,0.15);
    border-color: rgba(212,175,55,0.4);
    color: var(--agent-gold-lt);
    transform: translateY(-1px);
}

/* ── Footer / Input ─────────────────────────────────────────────────────────── */
.agent-panel__footer {
    padding: 12px 14px 10px;
    border-top: 1px solid var(--agent-border);
    background: rgba(0,0,0,0.2);
    flex-shrink: 0;
}

.agent-input-wrap {
    display: flex;
    gap: 8px;
    align-items: flex-end;
}

.agent-input {
    flex: 1 1;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 12px;
    color: rgba(255,255,255,0.92);
    font-family: 'Inter', sans-serif;
    font-size: 13.5px;
    padding: 10px 14px;
    resize: none;
    outline: none;
    line-height: 1.4;
    transition: border-color 0.2s, background 0.2s;
    min-height: 42px;
    max-height: 100px;
    overflow-y: auto;
}

.agent-input::placeholder { color: rgba(255,255,255,0.3); }

.agent-input:focus {
    border-color: rgba(212,175,55,0.4);
    background: rgba(255,255,255,0.09);
}

.agent-input:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.agent-send-btn {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: rgba(212,175,55,0.15);
    border: 1px solid rgba(212,175,55,0.25);
    color: rgba(212,175,55,0.5);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    flex-shrink: 0;
    padding: 0;
}

.agent-send-btn--active {
    background: linear-gradient(135deg, var(--agent-gold) 0%, var(--agent-gold-lt) 100%);
    border-color: var(--agent-gold);
    color: var(--agent-navy);
    box-shadow: 0 4px 16px rgba(212,175,55,0.35);
}

.agent-send-btn--active:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(212,175,55,0.5);
}

.agent-send-btn:disabled {
    cursor: not-allowed;
    transform: none !important;
}

/* ── Spinner ────────────────────────────────────────────────────────────────── */
.agent-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(212,175,55,0.3);
    border-top-color: var(--agent-gold);
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.agent-panel__powered {
    text-align: center;
    font-size: 10px;
    color: rgba(255,255,255,0.2);
    margin-top: 8px;
}

.agent-panel__powered strong {
    color: rgba(212,175,55,0.4);
}

/* ── Mobile responsive ─────────────────────────────────────────────────────── */
@media (max-width: 480px) {
    .agent-panel {
        width: calc(100vw - 20px);
        height: calc(100dvh - 110px);
        right: 10px;
        bottom: 96px;
        border-radius: 16px;
    }

    .agent-fab {
        bottom: 20px;
        right: 20px;
        width: 54px;
        height: 54px;
    }

    .agent-suggestions__grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/AgentChat.css"],"names":[],"mappings":"AAAA;;gFAEgF;;AAGhF,kFAAkF;AAClF;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,wCAAwC;IACxC,yCAAyC;IACzC,sBAAsB;IACtB,8EAA8E;IAC9E,gCAAgC;AACpC;;AAEA,kFAAkF;AAClF;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mFAAmF;IACnF,mCAAmC;IACnC,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0EAA0E;IAC1E,4DAA4D;IAC5D,aAAa;AACjB;;AAEA;IACI,uCAAuC;IACvC,4EAA4E;IAC5E,kCAAkC;AACtC;;AAEA;IACI,6DAA6D;IAC7D,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW,2CAA2C,EAAE;IACxD,YAAY,4EAA4E,EAAE;AAC9F;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,OAAO,mBAAmB,EAAE;IAC5B,OAAO,mBAAmB,EAAE;AAChC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA,kFAAkF;AAClF;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,qCAAqC;IACrC,kCAAkC;IAClC,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;IAC3B,mCAAmC;;IAEnC,cAAc;IACd,UAAU;IACV,uCAAuC;IACvC,oBAAoB;IACpB,uFAAuF;IACvF,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA,kFAAkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,qFAAqF;IACrF,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB,EAAE,iCAAiC;IACnD,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,YAAY,YAAY,EAAE;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;IACxC,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA,kFAAkF;AAClF;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,gCAAgC;AACpC;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oFAAoF;IACpF,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,oFAAoF;IACpF,uCAAuC;IACvC,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA,0BAA0B,2BAA2B,EAAE,gBAAgB,EAAE;AACzE,0BAA0B,4BAA4B,EAAE;AACxD;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,kDAAkD;AACtD;AACA,4CAA4C,qBAAqB,EAAE;AACnE,4CAA4C,qBAAqB,EAAE;;AAEnE;IACI,gBAAgB,qBAAqB,EAAE,YAAY,EAAE;IACrD,gBAAgB,mBAAmB,IAAI,UAAU,EAAE;AACvD;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA,iFAAiF;AACjF;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA,kFAAkF;AAClF;IACI,uBAAuB;IACvB,yCAAyC;IACzC,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,6BAA6B;IAC7B,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,8CAA8C;IAC9C,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,4BAA4B,4BAA4B,EAAE;;AAE1D;IACI,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iCAAiC;IACjC,uCAAuC;IACvC,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,oFAAoF;IACpF,+BAA+B;IAC/B,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,kFAAkF;AAClF;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,mCAAmC;IACnC,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,iFAAiF;AACjF;IACI;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════════════\n   HABIB AI Agent Chat Widget — Navy & Gold Premium Design\n   ═══════════════════════════════════════════════════════════════════════════ */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* ── Variables ──────────────────────────────────────────────────────────────── */\n.agent-fab,\n.agent-panel {\n    --agent-navy:     #0a1628;\n    --agent-navy-2:   #0f2044;\n    --agent-navy-3:   #162d5c;\n    --agent-gold:     #d4af37;\n    --agent-gold-lt:  #e8c84d;\n    --agent-surface:  rgba(10, 22, 40, 0.97);\n    --agent-border:   rgba(212, 175, 55, 0.2);\n    --agent-radius:   16px;\n    --agent-shadow:   0 20px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(212,175,55,0.15);\n    font-family: 'Inter', sans-serif;\n}\n\n/* ── Floating Action Button ─────────────────────────────────────────────────── */\n.agent-fab {\n    position: fixed;\n    bottom: 28px;\n    right: 28px;\n    z-index: 9990;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--agent-navy-3) 0%, var(--agent-navy) 100%);\n    border: 2px solid var(--agent-gold);\n    color: var(--agent-gold);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 8px 32px rgba(212, 175, 55, 0.3), 0 4px 16px rgba(0,0,0,0.4);\n    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    outline: none;\n}\n\n.agent-fab:hover {\n    transform: scale(1.08) translateY(-2px);\n    box-shadow: 0 12px 40px rgba(212, 175, 55, 0.45), 0 6px 20px rgba(0,0,0,0.5);\n    border-color: var(--agent-gold-lt);\n}\n\n.agent-fab--open {\n    background: linear-gradient(135deg, #dc3545 0%, #a71d2a 100%);\n    border-color: rgba(220, 53, 69, 0.6);\n    color: white;\n}\n\n.agent-fab--pulse {\n    animation: agent-pulse 2s infinite;\n}\n\n@keyframes agent-pulse {\n    0%, 100% { box-shadow: 0 8px 32px rgba(212,175,55,0.3); }\n    50%       { box-shadow: 0 8px 32px rgba(212,175,55,0.7), 0 0 0 12px rgba(212,175,55,0.1); }\n}\n\n.agent-fab__badge {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    width: 20px;\n    height: 20px;\n    background: #dc3545;\n    border-radius: 50%;\n    font-size: 11px;\n    font-weight: 700;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid var(--agent-navy);\n    animation: badge-appear 0.3s ease;\n}\n\n@keyframes badge-appear {\n    from { transform: scale(0); }\n    to   { transform: scale(1); }\n}\n\n.agent-fab__label {\n    position: absolute;\n    bottom: -22px;\n    left: 50%;\n    transform: translateX(-50%);\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--agent-navy);\n    letter-spacing: 0.5px;\n    white-space: nowrap;\n    text-shadow: 0 0 1px rgba(255,255,255,0.8);\n}\n\n/* ── Chat Panel ─────────────────────────────────────────────────────────────── */\n.agent-panel {\n    position: fixed;\n    bottom: 108px;\n    right: 28px;\n    z-index: 9980;\n    width: 400px;\n    height: 620px;\n    background: var(--agent-surface);\n    border: 1px solid var(--agent-border);\n    border-radius: var(--agent-radius);\n    box-shadow: var(--agent-shadow);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n\n    /* animation */\n    opacity: 0;\n    transform: translateY(20px) scale(0.97);\n    pointer-events: none;\n    transition: opacity 0.25s ease, transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    transform-origin: bottom right;\n}\n\n.agent-panel--open {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    pointer-events: all;\n}\n\n/* ── Header ─────────────────────────────────────────────────────────────────── */\n.agent-panel__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 18px;\n    background: linear-gradient(135deg, var(--agent-navy-3) 0%, var(--agent-navy-2) 100%);\n    border-bottom: 1px solid var(--agent-border);\n    flex-shrink: 0;\n}\n\n.agent-panel__header-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.agent-panel__avatar,\n.agent-msg__avatar {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    background: var(--surface-2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    overflow: hidden; /* Important for circular image */\n    border: 1px solid var(--gold-400);\n}\n\n.agent-fab-icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.agent-avatar-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n.agent-panel__status {\n    position: absolute;\n    bottom: 1px;\n    right: 1px;\n    width: 11px;\n    height: 11px;\n    background: #22c55e;\n    border-radius: 50%;\n    border: 2px solid var(--agent-navy-2);\n    animation: status-pulse 3s infinite;\n}\n\n@keyframes status-pulse {\n    0%, 100% { opacity: 1; }\n    50%       { opacity: 0.6; }\n}\n\n.agent-panel__name {\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--agent-gold);\n    letter-spacing: 0.3px;\n}\n\n.agent-panel__subtitle {\n    font-size: 11px;\n    color: rgba(255,255,255,0.5);\n    margin-top: 1px;\n}\n\n.agent-panel__header-actions {\n    display: flex;\n    gap: 4px;\n}\n\n.agent-panel__action-btn {\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    background: rgba(255,255,255,0.06);\n    border: 1px solid rgba(255,255,255,0.08);\n    color: rgba(255,255,255,0.6);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n    padding: 0;\n}\n\n.agent-panel__action-btn:hover {\n    background: rgba(212,175,55,0.15);\n    border-color: rgba(212,175,55,0.3);\n    color: var(--agent-gold);\n}\n\n/* ── Messages ───────────────────────────────────────────────────────────────── */\n.agent-panel__messages {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    scroll-behavior: smooth;\n}\n\n.agent-panel__messages::-webkit-scrollbar {\n    width: 4px;\n}\n.agent-panel__messages::-webkit-scrollbar-track {\n    background: transparent;\n}\n.agent-panel__messages::-webkit-scrollbar-thumb {\n    background: rgba(212,175,55,0.2);\n    border-radius: 4px;\n}\n.agent-panel__messages::-webkit-scrollbar-thumb:hover {\n    background: rgba(212,175,55,0.4);\n}\n\n/* ── Message bubbles ──────────────────────────────────────────────────────── */\n.agent-msg {\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n    animation: msg-appear 0.25s ease;\n}\n\n@keyframes msg-appear {\n    from { opacity: 0; transform: translateY(10px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n.agent-msg--user {\n    flex-direction: row-reverse;\n}\n\n.agent-msg__avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--agent-gold) 0%, var(--agent-gold-lt) 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    font-weight: 700;\n    color: var(--agent-navy);\n    flex-shrink: 0;\n}\n\n.agent-msg__bubble {\n    max-width: 82%;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.agent-msg__name {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--agent-gold);\n    padding-left: 2px;\n}\n\n.agent-msg__text {\n    padding: 10px 14px;\n    border-radius: 14px;\n    font-size: 13.5px;\n    line-height: 1.55;\n    color: rgba(255,255,255,0.92);\n    word-break: break-word;\n}\n\n.agent-msg--assistant .agent-msg__text {\n    background: rgba(255,255,255,0.07);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-bottom-left-radius: 4px;\n}\n\n.agent-msg--user .agent-msg__text {\n    background: linear-gradient(135deg, var(--agent-navy-3) 0%, rgba(22,45,92,0.9) 100%);\n    border: 1px solid rgba(212,175,55,0.25);\n    border-bottom-right-radius: 4px;\n    color: rgba(255,255,255,0.95);\n}\n\n.agent-msg__text strong { color: var(--agent-gold-lt); font-weight: 600; }\n.agent-msg__text em     { color: rgba(255,255,255,0.7); }\n.agent-msg__text code   {\n    background: rgba(0,0,0,0.4);\n    padding: 1px 5px;\n    border-radius: 4px;\n    font-family: 'Fira Code', monospace;\n    font-size: 12px;\n    color: var(--agent-gold-lt);\n}\n.agent-msg__text h3, .agent-msg__text h4 {\n    color: var(--agent-gold);\n    margin: 8px 0 4px;\n    font-size: 13px;\n}\n.agent-msg__text ul {\n    padding-left: 16px;\n    margin: 4px 0;\n}\n.agent-msg__text li {\n    margin-bottom: 2px;\n    color: rgba(255,255,255,0.85);\n}\n\n.agent-msg__time {\n    font-size: 10px;\n    color: rgba(255,255,255,0.3);\n    padding: 0 2px;\n    align-self: flex-end;\n}\n\n.agent-msg--user .agent-msg__time {\n    align-self: flex-end;\n    text-align: right;\n}\n\n/* ── Typing indicator ──────────────────────────────────────────────────────── */\n.agent-typing-indicator {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 14px;\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.06);\n    border-radius: 14px;\n    border-bottom-left-radius: 4px;\n    align-self: flex-start;\n    max-width: 160px;\n    animation: msg-appear 0.25s ease;\n}\n\n.agent-typing-indicator span {\n    width: 7px;\n    height: 7px;\n    background: var(--agent-gold);\n    border-radius: 50%;\n    animation: typing-bounce 1.4s infinite ease-in-out;\n}\n.agent-typing-indicator span:nth-child(2) { animation-delay: 0.2s; }\n.agent-typing-indicator span:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes typing-bounce {\n    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }\n    40%           { transform: scale(1);   opacity: 1; }\n}\n\n.agent-typing-indicator small {\n    font-size: 10px;\n    color: rgba(255,255,255,0.4);\n    white-space: nowrap;\n}\n\n/* ── Quick Suggestions ─────────────────────────────────────────────────────── */\n.agent-suggestions {\n    padding: 8px 4px;\n    animation: msg-appear 0.3s ease;\n}\n\n.agent-suggestions__label {\n    font-size: 11px;\n    color: rgba(255,255,255,0.4);\n    margin-bottom: 8px;\n    padding-left: 2px;\n}\n\n.agent-suggestions__grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 6px;\n}\n\n.agent-suggestions__btn {\n    background: rgba(212,175,55,0.06);\n    border: 1px solid rgba(212,175,55,0.2);\n    border-radius: 10px;\n    color: rgba(255,255,255,0.75);\n    font-size: 11.5px;\n    padding: 8px 10px;\n    cursor: pointer;\n    text-align: left;\n    font-family: 'Inter', sans-serif;\n    transition: all 0.2s;\n    line-height: 1.3;\n}\n\n.agent-suggestions__btn:hover {\n    background: rgba(212,175,55,0.15);\n    border-color: rgba(212,175,55,0.4);\n    color: var(--agent-gold-lt);\n    transform: translateY(-1px);\n}\n\n/* ── Footer / Input ─────────────────────────────────────────────────────────── */\n.agent-panel__footer {\n    padding: 12px 14px 10px;\n    border-top: 1px solid var(--agent-border);\n    background: rgba(0,0,0,0.2);\n    flex-shrink: 0;\n}\n\n.agent-input-wrap {\n    display: flex;\n    gap: 8px;\n    align-items: flex-end;\n}\n\n.agent-input {\n    flex: 1;\n    background: rgba(255,255,255,0.06);\n    border: 1px solid rgba(255,255,255,0.12);\n    border-radius: 12px;\n    color: rgba(255,255,255,0.92);\n    font-family: 'Inter', sans-serif;\n    font-size: 13.5px;\n    padding: 10px 14px;\n    resize: none;\n    outline: none;\n    line-height: 1.4;\n    transition: border-color 0.2s, background 0.2s;\n    min-height: 42px;\n    max-height: 100px;\n    overflow-y: auto;\n}\n\n.agent-input::placeholder { color: rgba(255,255,255,0.3); }\n\n.agent-input:focus {\n    border-color: rgba(212,175,55,0.4);\n    background: rgba(255,255,255,0.09);\n}\n\n.agent-input:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.agent-send-btn {\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    background: rgba(212,175,55,0.15);\n    border: 1px solid rgba(212,175,55,0.25);\n    color: rgba(212,175,55,0.5);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n    flex-shrink: 0;\n    padding: 0;\n}\n\n.agent-send-btn--active {\n    background: linear-gradient(135deg, var(--agent-gold) 0%, var(--agent-gold-lt) 100%);\n    border-color: var(--agent-gold);\n    color: var(--agent-navy);\n    box-shadow: 0 4px 16px rgba(212,175,55,0.35);\n}\n\n.agent-send-btn--active:hover {\n    transform: scale(1.05);\n    box-shadow: 0 6px 20px rgba(212,175,55,0.5);\n}\n\n.agent-send-btn:disabled {\n    cursor: not-allowed;\n    transform: none !important;\n}\n\n/* ── Spinner ────────────────────────────────────────────────────────────────── */\n.agent-spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(212,175,55,0.3);\n    border-top-color: var(--agent-gold);\n    border-radius: 50%;\n    animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n.agent-panel__powered {\n    text-align: center;\n    font-size: 10px;\n    color: rgba(255,255,255,0.2);\n    margin-top: 8px;\n}\n\n.agent-panel__powered strong {\n    color: rgba(212,175,55,0.4);\n}\n\n/* ── Mobile responsive ─────────────────────────────────────────────────────── */\n@media (max-width: 480px) {\n    .agent-panel {\n        width: calc(100vw - 20px);\n        height: calc(100dvh - 110px);\n        right: 10px;\n        bottom: 96px;\n        border-radius: 16px;\n    }\n\n    .agent-fab {\n        bottom: 20px;\n        right: 20px;\n        width: 54px;\n        height: 54px;\n    }\n\n    .agent-suggestions__grid {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
